export default __webpack_public_path__ + "static/media/agency3.6bdf77a3.png";